"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _a, _b;
"use strict";
const __1 = require("..");
class OMGroup extends __1.OMParty {
    constructor(object) {
        super(object);
        this.parties = [];
        this.groupCount = object.groupCount || 0;
        this.partyCount = object.partyCount || 0;
        this.parties = object.parties ? object.parties.map((party) => new __1.OMReference(__1.OMParty, party)) : [];
    }
    addMember(party) {
        try {
            const command = new OMGroup.AddMemberCommand(this, party);
            return __1.CommandManager.shared.addToQueue(command);
        }
        catch (error) {
            return Promise.reject(error);
        }
    }
    removeMember(party) {
        try {
            const command = new OMGroup.RemoveMemberCommand(this, party);
            return __1.CommandManager.shared.addToQueue(command);
        }
        catch (error) {
            return Promise.reject(error);
        }
    }
}
OMGroup.Type = "group";
OMGroup.Path = "groups";
OMGroup.AddMemberCommand = (_a = class AddMemberCommand extends __1.Command {
        constructor(receiver, party) {
            super(receiver);
            this.party = party;
        }
    },
    _a.Path = "add_member",
    _a.Type = "id_add_member_command",
    _a);
OMGroup.RemoveMemberCommand = (_b = class RemoveMemberCommand extends __1.Command {
        constructor(receiver, party) {
            super(receiver);
            this.party = party;
        }
    },
    _b.Path = "remove_member",
    _b.Type = "id_remove_member_command",
    _b);
exports.default = OMGroup;
//# sourceMappingURL=OMGroup.js.map